import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ResponseError } from '../../../models/common/Response';

export type UseDeleteEmployeeConfigMasterParams = {
    sid?: string;
    id?: string;
    role_access?: string;
};

export function useDeleteEmployeeConfigMaster(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        UseDeleteEmployeeConfigMasterParams
    >
) {
    return useMutation({
        mutationFn: (params) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.delete('/v1/configuration/lis/employee', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    sid: params?.sid,
                    id: params?.id,
                    role_access: params?.role_access,
                },
            });
        },
        ...options,
    });
}
